import FormModalConfig from 'types/generalEnums/FormModalConfigType';

const closeStatusProjectModalConfig: FormModalConfig = {
  btnText: 'Close',
  description: 'Do you want to close project?',
  headerTitle: 'Close Project'
};

export default closeStatusProjectModalConfig;
